<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ozKvjl/tc-custom/9780814338308.jpg?1726073140435" alt="This image is the cover for the book From Court to Forest, The Donald Haase Series in Fairy-Tale Studies"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">From Court to Forest, The Donald Haase Series in Fairy-Tale Studies
      </h1>
      <p class="bookDescription body article font2">
        <p> <b> <i>From Court to Forest</i> is a critical and historical study of the beginnings of the modern literary fairy tale.</b> </p><p> <i>From Court to Forest</i> is a critical and historical study of the beginnings of the modern literary fairy tale. Giambattista Basile's <i>Lo cunto de Ii cunti</i> written in Neapolitan dialect and published in 1634-36, comprises fifty fairy tales and was the first integral collection of literary fairy tales to appear in Western Europe. It contains some of the best known fairy-tales types, such as Sleeping Beauty, Puss in Boots, Cinderella, and others, many in their earliest versions. Although it became a central reference point for subsequent fairy tale writers, such as Perrault and the Grimms, as well as a treasure chest for folklorists,<i>Lo cunto de Ii cunti</i> has had relatively little attention devoted to it by literary scholars.</p><p> <i>Lo cunto</i>constituted a culmination of the erudite interest in popular culture and folk traditions that permeated the Renaissance. But even if Basile drew from the oral tradition, he did not merely transcribe the popular materials he heard and gathered around Naples and in his travels. He transformed them into original tales distinguished by vertiginous rhetorical play, abundant representations of the rituals of everyday life and the popular culture of the time, and a subtext of playful critique of courtly culture and the canonical literary tradition.</p><p>This work fills a gap in fairy-tale and Italian literary studies through its rediscovery of one of the most important authors of the Italian Baroque and the genre of the literary fairy tale.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Nancy L. Canepa
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wayne State University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?989a2758